module.exports = __webpack_public_path__ + "static/phigora-macbook@2x-ab6b2adce4c3257578313274051b2f5b.png";